import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { AnnualBar } from "./components/AnnualBar";
import { MonthPickerRow } from "./components/MonthPicker";
import { GroupBudgetTable } from "./components/GroupBudgetTable";

export function CostCentreBudgetPage() {
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Cost Centre-wise Budget
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Grouped by cost centre · click a row to expand cost heads
      </Typography>
      <AnnualBar />
      <MonthPickerRow />
      <GroupBudgetTable by="cc" label="Cost Centre" />
    </Box>
  );
}
